<template>
    <div class="newsevents-item">
        <a :href="newsEventItem.url" class="newsevents-item__link-wrap" v-bind:class="{nopage : newsEventItem.noPage}">
            <div class="newsevents-item__inner">
                <ResponsiveImage v-if="newsEventItem.imageHtml" :imageModel="newsEventItem.imageHtml" wrapClass="newsevents-item__image"  />
                <div class="newsevents-item__text">
                    <div class="newsevents-item__info-text">
                        <div class="newsevents-item__type">{{newsEventItem.typeName}}</div>
                        <div class="newsevents-item__date">{{newsEventItem.listDate}}</div>
                        <div class="newsevents-item__publisher" v-if="newsEventItem.publisher">{{ newsEventItem.publisher }}</div>
                    </div>
                    <div class="newsevents-item__text-row">
                        <h3 class="newsevents-item__headline">{{newsEventItem.listHeadline}}</h3>
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
    import ResponsiveImage from './responsiveImage.vue';
    import { objectFitPolyfill } from '../../vendor/object-fit-polyfill.js';
    
    export default {
        name: "NewsEventItem",
        components:{
            ResponsiveImage
        },
        props: ["newsEventItem"],
        mounted: function () {
            this.$nextTick(function () {
                objectFitPolyfill();
            })
        }
    };
</script>